import React from "react";
import { getStyleJSON } from "Utils/Common";
import userservice from "service/UserDataService";
import { DialogButton } from "Common/DialogButton";

export const SetMaxThreadsRow = () => {
  const [maxThreads, setMaxThreads] = React.useState("");
  return (
    <tr ng-init="setmaxthreadsconfig={}">
      <td
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; width: 100px;"
        )}
      >
        <input
          placeholder="Max Threads"
          style={{ width: "150px" }}
          value={maxThreads}
          onChange={(e) => {
            setMaxThreads(e.target.value);
          }}
          ng-model="setmaxthreadsconfig.amount" />
      </td>
      <td
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; text-align: center; font-size: 15px"
        )}
        align="center"
      >
        <DialogButton
          onClick={() => {
            userservice.setMaxThreads({ amount: maxThreads });
          }}
          label="SetThreads" />
      </td>
    </tr>
  );
};
